/**
 * ArchivedGroups Page Wrapper
 * Handles navigation for archived groups page
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArchivedGroups from './ArchivedGroups';

export const ArchivedGroupsWrapper: React.FC = () => {
  const navigate = useNavigate();

  // Handle back navigation - return to dashboard
  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <ArchivedGroups onBack={handleBack} />
  );
};

export default ArchivedGroupsWrapper;